import * as React from 'react';
import { cn } from './lib/cn.js';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('text-sm font-medium text-neutral-800', className)}
      {...props}
    />
  ),
);
Label.displayName = 'Label';
